export const HighPriorityIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7095_22297)">
        <path
          d="M4.6665 7.33333L7.99984 4L11.3332 7.33333"
          stroke="#FB3748"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6665 11.3333L7.99984 8L11.3332 11.3333"
          stroke="#FB3748"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7095_22297">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
